<template>
  <div class="">

    <div class="row">
      <form-group class="my-2 chat-form-tags col-lg-4 text-right " :validations="$v.form.tags">
        <div slot-scope="{ errors, invalid }">
          <label>تگ</label>

          <tag-filter1 @updateFilter="setTags"/>


          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group class="my-2 chat-form-users col-lg-4 text-right " :validations="$v.form.users">
        <div slot-scope="{ errors, invalid }">
          <label>کاربران</label>

          <user-filter1 @updateFilter="setUsers"/>


          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group class="my-2 chat-form-categories col-lg-4 text-right " :validations="$v.form.categories">
        <div slot-scope="{ errors, invalid }">
          <label>دسته بندی</label>

          <filter-category1 @updateFilter="setCategoryFilter"/>


          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
    </div>

    <div class="row">
      <form-group class="my-2 chat-form-files col-lg-4 text-right " :validations="$v.form.files">
        <div slot-scope="{ errors, invalid }">
          <label>فایل</label>

          <b-form-file
              multiple
              v-model="form.files"
              placeholder="فایل"
              drop-placeholder="فایل"
          ></b-form-file>

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group class="my-2 chat-form-group col-lg-4 text-right " :validations="$v.form.group">
        <div slot-scope="{ errors, invalid }">
          <label>گروه کاربران</label>

          <tag-filter1 @updateFilter="setUserGroup"/>


          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

    </div>

    <form @submit.prevent="onSubmit">

      <form-group class="  text-right mb-1" :validations="$v.form.subject">
        <div slot-scope="{ errors, invalid }">
          <label>موضوع</label>

          <textarea v-model="form.subject" type="text" class="form-control"/>

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group class="  text-right " :validations="$v.form.message">
        <div slot-scope="{ errors, invalid }">
          <label>پیام</label>

          <textarea v-model="form.message" type="text" class="form-control"/>

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group class=" my-3  text-right " :validations="$v.form.chat_type">
        <div slot-scope="{ errors, invalid }">
          <label>نوع چت</label>

          <div class="form-check form-check-inline">
            <input v-model="form.chat_type" class="form-check-input" type="radio" name="chat_type" id="chat_type_1"
                   value="0">
            <label class="mr-1 form-check-label" for="chat_type_1">عمومی</label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="form.chat_type" class="form-check-input" type="radio" name="chat_type" id="chat_type_2"
                   value="1">
            <label class="mr-1 form-check-label" for="chat_type_2">خصوصی</label>
          </div>


          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <div class="text-center my-3">
        <button class="btn btn-primary rounded-pill w-100" type="submit">ارسال</button>
      </div>


    </form>

  </div>
</template>


<script>

import FormGroup from "@/plugin/components/validator/FormGroup.vue";
import FormErrorsManager from "@/plugin/components/validator/FormErrorsManager.vue";
import {required} from "vuelidate/lib/validators";
import UserFilter1 from "@/plugin/components/dashboard/Filters/User/UserFilter1.vue";
import FilterCategory1 from "@/plugin/components/dashboard/Filters/Category/Category1/FilterCategory1.vue";
import TagFilter1 from "@/plugin/components/dashboard/Filters/Tag/TagFilter1.vue";

export default {
  name: "ChatForm",
  components: {TagFilter1, FilterCategory1, UserFilter1, FormErrorsManager, FormGroup},
  props: {
    submitFunction: {}
  },
  data() {
    return {
      form: {
        subject: '',
        message: '',
        files: [],
        categories: [],
        tags: [],
        group: [],
        users: [],
        chat_type: 0
      },
    }
  },
  validations: {
    form: {
      subject: {required},
      message: {required},
      files: {},
      categories: {},
      tags: {},
      group: {},
      users: {},
      chat_type: {required}
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        const form = this.form
        this.submitFunction(form)
      }
    },
    setUsers(data) {
      let chatTokens = data.usersObject.map(item => {
        return item.chat_token
      })
      this.form.users = chatTokens
    },
    setCategoryFilter(data) {
      this.form.categories = data.category
    },
    setTags(data) {
      this.form.tags = data.tags
    },
    setUserGroup(data) {

      this.form.group = []

      data.tags.forEach(item => {
        this.form.group.push(
            {
              'group_type': 'tag',
              'group_id': item,
              'group_on': 'user',
            }
        )
      })
    }
  }
}
</script>


<style scoped>

</style>